/** Sodium Club daily flash-sale countdown. */
(function () {
  'use strict';

  var formatUnit = function (value) {
    return String(value).padStart(2, '0');
  };

  var remainingToday = function () {
    var now = new Date();
    var midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0);
    var totalSeconds = Math.max(1, Math.ceil((midnight.getTime() - now.getTime()) / 1000));

    return [
      Math.floor(totalSeconds / 3600),
      Math.floor((totalSeconds % 3600) / 60),
      totalSeconds % 60
    ].map(formatUnit).join(':');
  };

  var render = function () {
    var remaining = remainingToday();
    document.querySelectorAll('[data-flash-countdown]').forEach(function (countdown) {
      countdown.textContent = remaining;
    });
  };

  render();
  window.setInterval(render, 1000);
  document.addEventListener('shopify:section:load', render);
  window.addEventListener('pageshow', render);
})();
